import { createSlice } from '@reduxjs/toolkit';
import { CONSUMPTION_TYPES } from 'config/app-config';
import type { RootState } from 'state/store';

export type ConsumptionEntryState = {
  data: {
    consumptionType:
      | null
      | typeof CONSUMPTION_TYPES[keyof typeof CONSUMPTION_TYPES];
  };
};

export const initialState: ConsumptionEntryState = {
  data: {
    consumptionType: null
  }
};

export const slice = createSlice({
  name: 'consumptionEntry',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setConsumptionType: (state, { payload }) => {
      state.data.consumptionType = payload;
    }
  }
});

export const { setInitialState, setConsumptionType } = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectSliceData = (state: RootState) => selectSlice(state).data;
export const selectConsumptionType = (state: RootState) =>
  selectSliceData(state).consumptionType;
export const selectIsDirectConsumption = (state: RootState) =>
  selectConsumptionType(state) === CONSUMPTION_TYPES.ACTUAL;

export default slice.reducer;
